import React, { Component } from 'react';

import { isEmpty } from "lodash";

import CloseIcon from '@mui/icons-material/Close';

import { normalizeStr } from '../../../utils/generalFuncs';
import { 
    Box,
} from '@mui/material';
import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';
import DatePicker from '../../common/DatePicker';
import { fetchNextSupplierAccount } from '../../../store/actions/suppliersAction';

class SuppliersForm extends Component {
    getSupplierCreatedAt = () => {
        if (!this.props.supplier) return null;
        
        // Vérifier si supplier_created_at est dans un champ JSON
        let jsonData = null;
        if (this.props.supplier.json) {
            // Si json est une chaîne, la parser
            if (typeof this.props.supplier.json === 'string') {
                try {
                    jsonData = JSON.parse(this.props.supplier.json);
                } catch (e) {
                    console.error('Error parsing supplier.json:', e);
                }
            } else {
                jsonData = this.props.supplier.json;
            }
        }
        
        // Chercher supplier_created_at dans le JSON ou directement dans supplier
        const createdAt = jsonData?.supplier_created_at || this.props.supplier.supplier_created_at;
        
        return createdAt ? new Date(createdAt) : null;
    }

    state = { 
        supplier_name: this.props.supplier ? this.props.supplier.supplier_name : "",
        supplier_category: this.props.supplier ? this.props.supplier.supplier_category : "",
        supplier_advance_category: this.props.supplier ? this.props.supplier.supplier_advance_category : "",
        supplier_code: this.props.supplier ? this.props.supplier.supplier_code : "",
        supplier_created_at: this.getSupplierCreatedAt(),
        errors:{
            supplier_name: "",
            supplier_category: "",
            supplier_code: "",
        }
    }
    // Compte d'avance auto : "4091" + ce qui suit "401" dans le compte fournisseur
    autoAdvance = ""
    computeAdvance = (category) => (
        typeof category === "string" && category.startsWith("401") ? "4091" + category.slice(3) : ""
    )
    componentDidMount() {
        this._mounted = true
        // Creation : le compte fournisseur peut deja etre prerempli
        if (!this.props.update && !this.state.supplier_advance_category) {
            this.autoAdvance = this.computeAdvance(this.state.supplier_category)
            if (this.autoAdvance) this.setState({ supplier_advance_category: this.autoAdvance })
        }
        // Creation seulement : proposer le prochain compte (calcule cote serveur)
        if (!this.props.update && !this.state.supplier_category) {
            this.prefillNextAccount()
        }
    }
    componentWillUnmount() {
        this._mounted = false
    }
    prefillNextAccount = async () => {
        const next = await fetchNextSupplierAccount()
        // echec : ne rien pre-remplir ; saisie deja commencee : ne pas ecraser
        if (!next || !this._mounted || this.state.supplier_category) return
        const advance = next.supplier_advance_category || this.computeAdvance(next.supplier_category)
        this.autoAdvance = advance
        this.setState({
            supplier_category: next.supplier_category,
            supplier_advance_category: this.state.supplier_advance_category || advance,
        })
    }
    // Compte deja pris (409 SUPPLIER_ACCOUNT_TAKEN) : renvoie le corps d'erreur, sinon null
    getAccountTakenError = (error) => (
        error && typeof error === "object" && error.code === "SUPPLIER_ACCOUNT_TAKEN" ? error : null
    )
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        if (name === "supplier_category") {
            const advance = this.computeAdvance(value)
            const current = this.state.supplier_advance_category
            // ne jamais ecraser une saisie manuelle ; en edition, seulement si vide
            const canFill = !current || (!this.props.update && current === this.autoAdvance)
            if (advance && canFill) {
                this.autoAdvance = advance
                this.setState({ [name]: value, supplier_advance_category: advance })
                return
            }
        }
        this.setState({
            [name]: value
        })
    }

    handleChangeDate = (date) => {
        this.setState({
            supplier_created_at: date
        })
    }
    
    validate = () => {
        let required = [
            "supplier_name",
            "supplier_category",
            "supplier_advance_category",
        ]
        
        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    nameExist = (name, id) => {
        const { SUPPLIERS } = this.props;
        let list = []
        list = Object.values(SUPPLIERS).filter(item =>  ( 
            (normalizeStr(item.supplier_name) === normalizeStr(name) ) && 
            (item.supplier_id !== id) 
        ) )
            
        console.log("Item exist",{list});
        return !isEmpty(list)
    }
    codeExist = (code, id) => {
        const { SUPPLIERS } = this.props;
        let list = []
        if(isEmpty(code)){
            return false
        }
        list = Object.values(SUPPLIERS).filter(item =>  ( 
            (normalizeStr(item.supplier_code) === normalizeStr(code) ) && 
            (item.supplier_id !== id) 
        ) )
            
        console.log("Item exist",{list});
        return !isEmpty(list)
    }

    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            if (this.props.update) {
                data = Object.assign(data, this.props.supplier)
            }
            data.supplier_name = this.state.supplier_name.toUpperCase()
            data.supplier_category = this.state.supplier_category
            data.supplier_advance_category = this.state.supplier_advance_category
            data.supplier_code = this.state.supplier_code
            
            // Sauvegarder la date de création dans le JSON
            if (this.props.update && this.state.supplier_created_at) {
                // Initialiser le champ json s'il n'existe pas
                if (!data.json) {
                    data.json = {}
                } else if (typeof data.json === 'string') {
                    try {
                        data.json = JSON.parse(data.json)
                    } catch (e) {
                        console.error('Error parsing supplier.json:', e)
                        data.json = {}
                    }
                }
                // Sauvegarder la date au format ISO
                data.json.supplier_created_at = this.state.supplier_created_at.toISOString()
            }
    
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            
            // check if name exist
            if(this.nameExist(data.supplier_name, data.supplier_id) ){
                this.props.notif("error",`Ce Fournisseur existe déjà`)
                return
            }
            if(this.codeExist(data.supplier_code, data.supplier_id) ){
                this.props.notif("error",`Ce code est déja utilisé`)
                return
            }

            if(this.props.update){
                await this.props.updateSupplier(data)
            } else {
                await this.props.newSupplier(data)  
            }

            const requestError = this.props.STATE.suppliers.error
            const accountTaken = this.getAccountTakenError(requestError)
            if(accountTaken){
                this.props.notif("error", accountTaken.error || "Ce compte fournisseur est déjà utilisé")
                if (accountTaken.next) {
                    // proposer le compte suivant ; le compte d'avance suit
                    const advance = this.computeAdvance(accountTaken.next)
                    this.autoAdvance = advance
                    this.setState({
                        supplier_category: accountTaken.next,
                        supplier_advance_category: advance || this.state.supplier_advance_category,
                    })
                }
            } else if(requestError){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.suppliers );
                console.log('====================================');
                this.props.notif("error",`Un problème est survenu: ${(requestError && requestError.error) || requestError}`)
            } else {
                !this.props.update && this.props.notif("success","Le fournisseur a été créé avec succès")
                this.props.update && this.props.notif("success","Le fournisseur a été modifiée avec succès")
                this.props.handleClose()
                // this.clearForms()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        return (
            <Dialog
                open={true}
                close={this.props.handleClose}
                maxWidth="sm"
                fullWidth
                appBar
                title={`${this.props.update ? "Modifier le " : "Créer un nouveau"} Fournisseur`}
                submitAction={this.handleSubmit}
                disabledSubmit={this.props.STATE.suppliers.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
            >
                <Box p={3} >
                    <InputText
                        required
                        name="supplier_name" 
                        id="supplier_name" 
                        value={this.state.supplier_name} 
                        label="Nom" 
                        placeholder="Nom du fournisseur" 
                        error={this.state.errors.supplier_name} 
                        onChange={this.handleChange}
                    />
                    <InputText
                        name="supplier_category" 
                        id="supplier_category" 
                        value={this.state.supplier_category} 
                        label="Compte Fournisseur" 
                        placeholder="Ex: 401..." 
                        error={this.state.errors.supplier_category} 
                        onChange={this.handleChange}
                        required
                    />
                    <InputText
                        name="supplier_advance_category" 
                        id="supplier_advance_category" 
                        value={this.state.supplier_advance_category} 
                        label="Compte Avance Fournisseur" 
                        placeholder="Ex: 4091..." 
                        error={this.state.errors.supplier_advance_category} 
                        onChange={this.handleChange}
                        required
                    />
                    {this.props.update && (
                        <DatePicker
                            name="supplier_created_at" 
                            id="supplier_created_at" 
                            label="Date de création" 
                            value={this.state.supplier_created_at}
                            handleChange={this.handleChangeDate}
                            noPadding={false}
                        />
                    )}
                    {/* <TextField
                        name="supplier_code" 
                        id="supplier_code" 
                        value={this.state.supplier_code} 
                        label="Code Fournisseur" 
                        error={this.state.errors.supplier_code} 
                        onChange={this.handleChange}
                    /> */}
                </Box>
                
            </Dialog>
        );
    }
}

export default SuppliersForm;